export default {
  approved: 'approved',
  pending: 'pending',
  disapproved: 'disapproved'
};
